import Index from './handlers/index'
import BaseObject from './handlers/object'
import ObjectText from './handlers/object.text'
import ObjectJson from './handlers/object.json'
import ObjectJsonArray from './handlers/object.json.array'
import ObjectJsonObject from './handlers/object.json.object'

const resources = {
  'index': new Index,
  'object': new BaseObject,
  'object.text': new ObjectText,
  'object.json': new ObjectJson,
  'object.json.array': new ObjectJsonArray,
  'object.json.object': new ObjectJsonObject,
}

class MessageManager {
  constructor (repository) {
    this.repository = repository
  }

  dispatch (messages) {
    for (const message of messages) {
      console.log('[CARRIER] Got message', message)
      resources[message.resource.type][message.name](this.repository, message.resource, message.content)
    }
  }
}

export default MessageManager